import { CircleMarker } from "react-leaflet";
import { ICoord } from "../../../@types/GoogleMaps/ICoord";
import { LeafletStaticMap } from "../../Leaflet/LeafletStaticMap/Index";

interface RainfallPointMapProps {
  point: ICoord;
}

export default function RainfallPointMap({ point }: RainfallPointMapProps) {
  return (
    <LeafletStaticMap center={point}>
      <CircleMarker center={point} radius={8} pathOptions={{ color: "#62b8ae", fillColor: "#62b8ae", fillOpacity: 1 }} />
    </LeafletStaticMap>
  );
}
